import React, { useEffect, useMemo, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import './AddWorkWithModal.css';
import CheckboxOption from '../CheckboxOption/CheckboxOption';
import TauriLoader2 from '../../TauriLoader2/TauriLoader2';
import appURL from '../../../appURL.json';

const AddWorkWithModal = ({ show, onHide, worksheet, selectedDate, workWithEmployees, isCreating, onProceed }) => {
    const [checkedEmployees, setCheckedEmployees] = useState({});

    const handleCheckboxChange = (empId) => {
        setCheckedEmployees(prev => ({
            ...prev,
            [empId]: !prev[empId]
        }));
    };

    const getWorkWithFromWorksheet = () => {
        if (!worksheet?.Days) return [];

        const key = selectedDate?.toLocaleDateString("en-CA"); // YYYY-MM-DD
        const day = worksheet.Days[key];
        return Array.isArray(day?.workWith) ? day.workWith : [];
    };

    const formatReadableDate = (input) => {
        const d = new Date(input);
        return d.toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric"
        });
    };

    const handleProceed = () => {
        const finalSelected = Object.keys(checkedEmployees)
            .filter(id => checkedEmployees[id])
            .map(id => Number(id));

        const original = getWorkWithFromWorksheet();

        const sortedFinal = [...finalSelected].sort((a, b) => a - b);
        const sortedOriginal = [...original].sort((a, b) => a - b);

        const noChanges =
            sortedFinal.length === sortedOriginal.length &&
            sortedFinal.every((v, i) => v === sortedOriginal[i]);

        if (noChanges) {
            onHide();
            return;
        }

        const payload = {
            Date: selectedDate ? selectedDate.toLocaleDateString("en-CA") : null,
            EmployeeIds: finalSelected
        }

        onProceed?.(payload);
    };


    useEffect(() => {
        const workWithList = getWorkWithFromWorksheet();
        const obj = {};
        workWithList.forEach(id => {
            obj[id] = true;
        });

        setCheckedEmployees(obj);
    }, [worksheet, selectedDate]);

    return (
        <Modal
            className='add-workwith-modal'
            show={show}
            onHide={onHide}
            size="lg"
            centered
        >
            <Modal.Header>Work With ({formatReadableDate(selectedDate)})</Modal.Header>

            <Modal.Body>
                <div className="schedule-options">
                    {workWithEmployees.map(emp => (
                        <CheckboxOption
                            key={emp.accountID}
                            label={emp.name}
                            checked={!!checkedEmployees[emp.accountID]}
                            onChange={() => handleCheckboxChange(emp.accountID)}
                        />
                    ))}
                </div>
            </Modal.Body>


            <Modal.Footer className="justify-content-end">
                <Button className='btn-proceed d-flex align-items-center' disabled={isCreating} onClick={handleProceed}>
                    {isCreating && (
                        <TauriLoader2 width="1.2rem" height="1.2rem" borderwidth="0.2rem" color="#1D5D9B" />
                    )}
                    <span className="text-nowrap">Proceed</span>
                </Button>

                <Button className="btn-cancel d-flex" disabled={isCreating} onClick={onHide}>
                    <span className="text-nowrap">Cancel</span>
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddWorkWithModal;
